export { default } from './ShaqsFavorites';
